window._ = require('lodash')
window.__ = require('underscore')
window.Popper = require('popper.js').default

window.moment = require('moment')

window.LZString = require('lz-string')

import repo from '@repositories/repo'
window.repo = repo

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery')
    //window.$ = $.extend(require('jquery-ui-bundle'));
    window.$ = $.extend(require('jquery-ui/ui/widgets/datepicker.js'))

    require('bootstrap')
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error(
        'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'
    )
}

window.toastr = require('toastr')
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js')

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     wsHost: process.env.MIX_WSHOST,
//     wsPort: process.env.MIX_WSPORT,
//     forceTLS: true,
//     encrypted: process.env.MIX_WSENCRYPTED.toLocaleLowerCase() === 'true',
//     scheme: process.env.MIX_WSSCHEME
// });

String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '')
}
String.prototype.toCamel = function() {
    let txt = this.replace(/(\_\w)/g, function(m) {
        return m[1].toUpperCase()
    })
    txt = txt.replace(/(\-\w)/g, function(m) {
        return m[1].toUpperCase()
    })
    return txt
}
String.prototype.toDash = function() {
    return this.replace(/([A-Z])/g, function($1) {
        return '-' + $1.toLowerCase()
    })
}
String.prototype.toUnderscore = function() {
    return this.replace(/([A-Z])/g, function($1) {
        return '_' + $1.toLowerCase()
    })
}
const linkifyUrls = require('linkify-urls')
String.prototype.linkify = function() {
    return linkifyUrls(this, {
        attributes: {
            class: 'linkified',
        },
    })
}
